export const onClickConfirmAndUnlockEffect = (options = {}) => {
  const { onClickConfirmRun } = options;
  return (e) => onClickConfirmRun(e, { unlock: true });
};
